import React from 'react';
import {Button, Divider} from '@mui/material';
import {ArrowLeftIcon} from '$assets/svgs';
import PatientBreadcrumb from '~/modules/frontdesk/PatientList/PatientDetails/PatientBreadcrumb';

interface QuestionnaireHeaderProps {
  handleBack: () => void;
  'data-testid'?: string;
  patientName?: string;
}

const QuestionnaireHeader: React.FC<QuestionnaireHeaderProps> = ({
  handleBack,
  'data-testid': testId,
  patientName,
}) => {
  return (
    <header
      className="flex flex-col font-primary bg-primary h-fit"
      data-testid={testId}
    >
      <div className="px-10 py-5 border-0 border-b-1 border-solid border-divider flex items-center justify-between">
        <Button
          startIcon={<ArrowLeftIcon />}
          className="!normal-case !font-normal !text-base !leading-6 !tracking-tighter text-primary-dark"
          onClick={handleBack}
        >
          Back to clinical data
        </Button>
        {patientName && <PatientBreadcrumb patientName={patientName} />}
      </div>
      <Divider className="pt-5 px-10" />
    </header>
  );
};

export default QuestionnaireHeader;
